import { CardBrand } from '../models/card-brand.enum';
import { CreditCard } from '../models/model';

export function cardBrandImageUrl(creditCard: CreditCard): string {
  return `/assets/images/credit_card/${creditCard.brand.toLowerCase()}.png`;
}

export function cardBrandImageUrlByBrandCode(brand: CardBrand): string {
  return `/assets/images/credit_card/${brand.toLowerCase()}.png`;
}
